import DOMPurify from 'dompurify'

const VueDOMPurify = {
  install(Vue) {
    Vue.prototype.$domPurify = DOMPurify
  },
}

export default VueDOMPurify
